/**
 * Study↔Site assignment status — API uses SCREAMING_SNAKE; UI often Title Case.
 */

import { createStatusHelpers } from "./statusHelpers";

export const STUDY_SITE_ASSIGNMENT_STATUS = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  COMPLETED: "COMPLETED",
} as const;

export type StudySiteAssignmentStatusValue =
  (typeof STUDY_SITE_ASSIGNMENT_STATUS)[keyof typeof STUDY_SITE_ASSIGNMENT_STATUS];

/** Title Case values used in Site/Study list filters. */
export const STUDY_ASSIGNMENT_STATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  PENDING: "Pending",
  SUSPENDED: "Suspended",
} as const;

export type StudyAssignmentUiStatus =
  (typeof STUDY_ASSIGNMENT_STATUS)[keyof typeof STUDY_ASSIGNMENT_STATUS];

const apiHelpers = createStatusHelpers(
  STUDY_SITE_ASSIGNMENT_STATUS,
  STUDY_SITE_ASSIGNMENT_STATUS.PENDING,
  {
    Active: STUDY_SITE_ASSIGNMENT_STATUS.ACTIVE,
    Inactive: STUDY_SITE_ASSIGNMENT_STATUS.INACTIVE,
    Pending: STUDY_SITE_ASSIGNMENT_STATUS.PENDING,
    Completed: STUDY_SITE_ASSIGNMENT_STATUS.COMPLETED,
  },
);

export const STUDY_SITE_ASSIGNMENT_STATUS_VALUES = apiHelpers.VALUES;
export const tryNormalizeStudySiteAssignmentStatus = apiHelpers.tryNormalize;
export const normalizeStudySiteAssignmentStatus = apiHelpers.normalize;
export const isStudySiteAssignmentStatus = apiHelpers.isStatus;
export const isAnyStudySiteAssignmentStatus = apiHelpers.isAnyStatus;

const uiHelpers = createStatusHelpers(
  STUDY_ASSIGNMENT_STATUS,
  STUDY_ASSIGNMENT_STATUS.ACTIVE,
  {
    ACTIVE: STUDY_ASSIGNMENT_STATUS.ACTIVE,
    INACTIVE: STUDY_ASSIGNMENT_STATUS.INACTIVE,
    PENDING: STUDY_ASSIGNMENT_STATUS.PENDING,
    SUSPENDED: STUDY_ASSIGNMENT_STATUS.SUSPENDED,
  },
);

export const STUDY_ASSIGNMENT_STATUS_VALUES = uiHelpers.VALUES;
export const tryNormalizeStudyAssignmentUiStatus = uiHelpers.tryNormalize;
export const normalizeStudyAssignmentUiStatus = uiHelpers.normalize;
export const isStudyAssignmentUiStatus = uiHelpers.isStatus;
export const isAnyStudyAssignmentUiStatus = uiHelpers.isAnyStatus;

/** Role assignment status (user↔study/site role rows). */
export const ROLE_ASSIGNMENT_STATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SUSPENDED: "Suspended",
} as const;

export type RoleAssignmentStatus =
  (typeof ROLE_ASSIGNMENT_STATUS)[keyof typeof ROLE_ASSIGNMENT_STATUS];

const roleHelpers = createStatusHelpers(
  ROLE_ASSIGNMENT_STATUS,
  ROLE_ASSIGNMENT_STATUS.ACTIVE,
);

export const ROLE_ASSIGNMENT_STATUS_VALUES = roleHelpers.VALUES;
export const tryNormalizeRoleAssignmentStatus = roleHelpers.tryNormalize;
export const normalizeRoleAssignmentStatus = roleHelpers.normalize;
export const isRoleAssignmentStatus = roleHelpers.isStatus;
export const isAnyRoleAssignmentStatus = roleHelpers.isAnyStatus;
